import { useContext, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "@config/constant";
import { OspApiClientContext } from "@features/api/client/OspApiClientProvider";

export const useAgentMessage = ({
  chatId,
  messageId,
  enabled,
}: {
  chatId: string;
  messageId: string;
  enabled: boolean;
}) => {
  const { chatApi } = useContext(OspApiClientContext);

  // 使用 useMemo 缓存 queryKey
  const messageAgentsQueryKey = useMemo(
    () => [QUERY_KEYS.CHAT_MESSAGE_AGENTS, chatId, messageId],
    [chatId, messageId],
  );

  const { data, isLoading } = useQuery({
    queryKey: messageAgentsQueryKey,
    enabled: !!messageId && !!chatId && enabled,
    queryFn: async () => {
      const res = await chatApi?.chats
        .messagesAgentsList(chatId, messageId)
        .catch((error) => {
          return Promise.reject(error);
        });
      if (res?.error) {
        return Promise.reject(res?.error);
      }
      return res?.data?.data?.agents || [];
    },
    // 使用 gcTime 替代 cacheTime
    staleTime: 5 * 60 * 1000, // 5分钟内不重新请求
    gcTime: 10 * 60 * 1000, // 10分钟后进行垃圾回收
  });

  return {
    data,
    isLoading,
  };
};
